// This function allow to reference async chunks
__webpack_require__.miniCssF = (chunkId) => {
	// return url for filenames based on template
	return "static/css/" + chunkId + "." + {"65":"393bc865","512":"caf71371"}[chunkId] + ".chunk.css";
};